// Xuất danh sách Chủ vườn + Vườn ra 1 file .xlsx (exceljs — không dùng skill
// xlsx Anthropic, xem CLAUDE.md). Pattern tải xuống giống xuatExcelChungTu.

import ExcelJS from "exceljs";
import { NHAN_LOAI_CHU_VUON } from "lib/quyTacMaChuVuon";
import { soCccdDayDuTuHoSo } from "lib/cccdBaoMat";

const TEN_CONG_TY = "CÔNG TY TNHH LV NÔNG NGHIỆP";
const MAU_HEADER = "FFEFEFEF";

async function taiXuong(workbook, tenFile) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = tenFile;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

function themHeader(sheet, hangSo, cotList) {
  const hang = sheet.getRow(hangSo);
  cotList.forEach((c, i) => {
    const cell = hang.getCell(i + 1);
    cell.value = c.header;
    cell.font = { bold: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: MAU_HEADER } };
    cell.alignment = { horizontal: "center", wrapText: true };
    sheet.getColumn(i + 1).width = c.width ?? 16;
  });
}

function tieuDeSheet(sheet, tieuDe, soCot) {
  sheet.mergeCells(1, 1, 1, soCot);
  sheet.getCell(1, 1).value = TEN_CONG_TY;
  sheet.getCell(1, 1).font = { bold: true };

  sheet.mergeCells(2, 1, 2, soCot);
  sheet.getCell(2, 1).value = tieuDe;
  sheet.getCell(2, 1).font = { bold: true, size: 13 };

  sheet.mergeCells(3, 1, 3, soCot);
  sheet.getCell(3, 1).value = `Xuất ngày ${new Date().toLocaleString("vi-VN")}`;
  sheet.getCell(3, 1).font = { italic: true, size: 10 };
}

function chuoi(v) {
  if (v == null || v === "") return "";
  if (Array.isArray(v)) return v.filter(Boolean).join(", ");
  return String(v);
}

/**
 * @param {object} p
 * @param {Array} p.danhSachChuVuon
 * @param {Array} p.danhSachVuon
 * @param {Record<string, string>} [p.tenChuVuonTheoId] - map id chủ vườn → họ tên
 */
export async function xuatExcelChuVuonVuon({
  danhSachChuVuon = [],
  danhSachVuon = [],
  tenChuVuonTheoId = {},
}) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = TEN_CONG_TY;

  const cotChuVuon = [
    { header: "Mã chủ vườn", width: 18 },
    { header: "Họ và tên", width: 22 },
    { header: "Loại", width: 16 },
    { header: "CCCD", width: 18, numFmt: "@" },
    { header: "Ngày sinh", width: 12 },
    { header: "SĐT", width: 12 },
    { header: "Email", width: 22 },
    { header: "Ngày cấp CCCD", width: 14 },
    { header: "Nơi cấp CCCD", width: 18 },
    { header: "Địa chỉ", width: 24 },
    { header: "Thôn/Ấp", width: 14 },
    { header: "Xã", width: 16 },
    { header: "Tỉnh", width: 14 },
    { header: "Mã tỉnh", width: 10 },
    { header: "Mã xã", width: 10 },
    { header: "Ngân hàng", width: 18 },
    { header: "Số TK", width: 16 },
    { header: "Chủ tài khoản", width: 20 },
    { header: "Ghi chú", width: 24 },
  ];

  const sheetCv = workbook.addWorksheet("Chủ vườn");
  tieuDeSheet(sheetCv, "Danh sách chủ vườn", cotChuVuon.length);
  themHeader(sheetCv, 5, cotChuVuon);

  danhSachChuVuon.forEach((cv) => {
    sheetCv.addRow([
      chuoi(cv.maChuVuon),
      chuoi(cv.hoTen),
      NHAN_LOAI_CHU_VUON[cv.loaiChuVuon] || chuoi(cv.loaiChuVuon) || "—",
      chuoi(soCccdDayDuTuHoSo(cv)),
      chuoi(cv.ngaySinh),
      chuoi(cv.sdt),
      chuoi(cv.email),
      chuoi(cv.ngayCapCccd),
      chuoi(cv.noiCapCccd),
      chuoi(cv.diaChi),
      chuoi(cv.thon),
      chuoi(cv.xa),
      chuoi(cv.tinh),
      chuoi(cv.tinhMa),
      chuoi(cv.xaMa),
      chuoi(cv.tenNganHang),
      chuoi(cv.soTkNganHang),
      chuoi(cv.chuTaiKhoan),
      chuoi(cv.ghiChu),
    ]);
  });

  const cotVuon = [
    { header: "Tên vườn", width: 20 },
    { header: "Chủ vườn", width: 22 },
    { header: "Mã chủ vườn (CCCD/id)", width: 18 },
    { header: "Giống bơ", width: 24 },
    { header: "Địa chỉ chi tiết", width: 24 },
    { header: "Thôn/Ấp", width: 14 },
    { header: "Xã", width: 16 },
    { header: "Tỉnh", width: 14 },
    { header: "Diện tích (ha)", width: 12 },
    { header: "Năm bắt đầu trồng", width: 14 },
    { header: "Số cây", width: 10 },
    { header: "Mã số vùng trồng", width: 16 },
    { header: "Chứng nhận", width: 18 },
    { header: "Ghi chú", width: 24 },
  ];

  const sheetV = workbook.addWorksheet("Vườn");
  tieuDeSheet(sheetV, "Danh sách vườn", cotVuon.length);
  themHeader(sheetV, 5, cotVuon);

  danhSachVuon.forEach((v) => {
    const tenChu =
      tenChuVuonTheoId[v.maChuVuon] ||
      danhSachChuVuon.find((cv) => cv.id === v.maChuVuon)?.hoTen ||
      "";
    sheetV.addRow([
      chuoi(v.tenVuon),
      chuoi(tenChu),
      chuoi(v.maChuVuon),
      chuoi(v.giongBo),
      chuoi(v.diaChiChiTiet),
      chuoi(v.thon),
      chuoi(v.xa),
      chuoi(v.tinh),
      v.dienTichHa ?? "",
      v.namBatDauTrong ?? "",
      v.soCay ?? "",
      chuoi(v.maSoVungTrong),
      chuoi(v.chungNhan),
      chuoi(v.ghiChu),
    ]);
  });

  const stamp = new Date().toISOString().slice(0, 10);
  await taiXuong(workbook, `chu-vuon-vuon-${stamp}.xlsx`);
}
